import { CreateMixin } from "@pdfking/reactivity/preact"

export const InputMixin = CreateMixin({
  props: {
    disabled: false,
    dom_id: "",
  },
})
